import { Component, OnInit } from '@angular/core';
import { StateService } from '@uirouter/core';
import { DeviceStatusViewInfoQueryService } from '../shared/services/device-status-view-info-query.service';

@Component({
    selector: 'dl-device-search',
    templateUrl: './device-search.component.html',
    styleUrls: ['./device-search.component.scss']
})
export class DeviceSearchComponent implements OnInit {
    public static $name: string = 'deviceSearch';

    locationId: number;
    jobNumber: number;
    isMapEnabled = true;
    isReady = false;

    get params() {
        return this.stateService.params;
    }

    constructor(
        private stateService: StateService,
        private deviceStatusViewInfoQueryService: DeviceStatusViewInfoQueryService,
    ) {
    }

    ngOnInit() {
        if (this.params.query) {
            this.deviceStatusViewInfoQueryService.setQuery(this.params.query);
        }
        this.isReady = true;
    }

    ngOnDestroy() {
        this.deviceStatusViewInfoQueryService.clearQuery();
    }

    toggleMap() {
        this.isMapEnabled = !this.isMapEnabled;
    }
}
